import { F0Box, F0Form, F0Heading, F0Icon, F0Text } from '@factorialco/f0-react'
import { MoneyBag } from '@factorialco/f0-react/icons/app'
import { AiCreditsSettingsDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { useCreditsForm } from './form'

export const CreditsPage = () => {
  const { company } = useCurrentSession()

  const { data, loading } = useQuery(AiCreditsSettingsDocument, {
    variables: { companyId: company.id },
  })

  if (loading) {
    return <Loading />
  }

  const employeeCreditCap =
    data?.aiCredits.creditSettingsConnection.nodes[0]?.employeeCreditCap ?? undefined

  return <CreditsPageContent employeeCreditCap={employeeCreditCap} />
}

interface CreditsPageContentProps {
  employeeCreditCap: number | null | undefined
}

const CreditsPageContent = ({ employeeCreditCap }: CreditsPageContentProps) => {
  const { formDefinition } = useCreditsForm({ employeeCreditCap })

  return (
    <F0Box display="flex" flexDirection="column" gap="2xl" width="full" maxWidth="1/2">
      <F0Box display="flex" flexDirection="column" gap="md">
        <F0Box alignItems="center" display="flex" gap="sm">
          <F0Icon icon={MoneyBag} size="lg" />
          <F0Heading content={i18n.t('ai.settings.credits_tab.title')} variant="heading-large" />
        </F0Box>
        <F0Text content={i18n.t('ai.settings.credits_tab.description')} variant="description" />
      </F0Box>
      <F0Box border="default" padding="lg" borderRadius="lg">
        <F0Form formDefinition={formDefinition} className="max-w-full" />
      </F0Box>
    </F0Box>
  )
}
